<div [ngClass]="course.enrollmentClass">{{displayStatus}}</div>
